import Command from '@ckeditor/ckeditor5-core/src/command';

export default class InsertHSButtonCommand extends Command {
    execute() {
        this.editor.model.change( writer => {
					const hsButtonOptions = this.editor.config.get("hsButtonOptions");
					if(hsButtonOptions == undefined){
						return;
					}
					// Insert <hsButton>*</hsButton> at the current selection position
					// in a way that will result in creating a valid model structure.
					const hsButton = writer.createElement( 'hsButton' );
					// writer.appendText( hsButtonOptions.buttonText, hsButton );

					this.editor.model.insertContent( hsButton );
        } );
    }

    refresh() {
				const hsButtonOptions = this.editor.config.get("hsButtonOptions");
				if(hsButtonOptions == undefined){
					return;
				}
        const model = this.editor.model;
        const selection = model.document.selection;
        const allowedIn = model.schema.findAllowedParent( selection.getFirstPosition(), 'hsButton' );
				const hsButtons = findNodes(model, 'hsButton', this.editor.model.document.getRoot());
        this.isEnabled = allowedIn !== null && hsButtons.length < hsButtonOptions.numButtonsRequired;
    }
}

const findNodes = function(model, type, root) {
    const nodes = [];
		const range = model.createRangeIn(model.document.getRoot());
    for ( const value of range.getWalker({ ignoreElementEnd: true }) ) {
        const node = value.item;
        if ( node.is('element', type ) ) {
            nodes.push(node);
        }
    }
    return nodes;
};